import { Box, Chip, Link } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import CDGridPro from '../../components/CDGridPro';

const columns: GridColDef[] = [
    {
        field: 'id',
        headerName: 'Status',
        width: 90,
        display: 'flex',
        renderCell: (params) => {
            return (
                <Link
                    onClick={(event) => event.stopPropagation()}
                    href={'https://advertising.amazon.com/dsp/ENTITY'}
                    target="_blank"
                    rel="noreferrer"
                >
                    <Chip variant="filled" color="success" label="Status" />
                </Link>
            );
        },
    },
    {
        field: 'firstName',
        headerName: 'First name',
        width: 150,
        editable: true,
        display: 'flex',
    },
    {
        field: 'lastName',
        headerName: 'Last name',
        width: 150,
        editable: true,
        display: 'flex',
    },
    {
        field: 'age',
        headerName: 'Age',
        type: 'number',
        width: 110,
        editable: true,
        display: 'flex',
    },
    {
        field: 'fullName',
        headerName: 'Full name',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 160,
        display: 'flex',
        valueGetter: (value: string, row: { firstName: string; lastName: string }) => {
            return [row.firstName, row.lastName].filter(Boolean).join(' ');
        },
    },
];

const rows = [
    { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
    { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
    { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
    { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
    { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
    { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
    { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
    { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
    { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
];

export default function GridDemo() {
    return (
        <Box sx={{ height: 400, width: '100%' }}>
            <CDGridPro
                showToolbar={false}
                rows={rows}
                columns={columns}
                initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
            />
        </Box>
    );
}
